import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import type { ConditionsRes } from 'features/conditions/types/conditions.types'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchConditions = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const { data: conditions, isPending: isConditionsLoading } = useQuery<ConditionsRes>({
		queryKey: queryKeys.conditions.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.conditions(query ?? '')),
		enabled: !!auth.accessToken
	})

	return {
		conditions,
		isConditionsLoading
	}
}
